export function legacyMarketingLocation(query = {}) {
  const sections = {marketing: 'google-ads', editorial: 'organika', calendar: 'social'};
  const section = sections[query.section] || (['calendar', 'articles', 'social', 'ads', 'settings'].includes(query.tab) ? 'social' : null);
  return section ? {name: 'KartaMarketing', query: {...query, section}} : null;
}
